import { Tabs } from "@finanedi.es/storybook"
import { useActivoById } from "api/Activo.hook"
import { useTranslation } from "react-i18next"
import { useParams } from "react-router-dom"
import { ResumenAmortizacion } from "./ResumenAmortizacion"
import { TabAmortizacion } from "./TabAmortizacion"
import { TabDetallesGenerales } from "./TabDetallesGenerales"

export const TabsDetail = ({
  openAmortizar,
}: {
  openAmortizar: () => void
}) => {
  const { t } = useTranslation()
  const { activoId } = useParams<{ activoId: string }>()
  const { activoByIdData } = useActivoById(activoId)
  const showTabs = activoByIdData?.esAmortizable

  return (
    <div className='tw-px-6 tw-pb-6 tw-flex tw-flex-row tw-gap-x-6 tw-h-[calc(100%-72px)]'>
      <div className='tw-w-3/4 tw-h-full'>
        {!showTabs ? (
          <TabDetallesGenerales />
        ) : (
          <Tabs
            tabs={[
              {
                element: (
                  <div
                    key='AmortizacionTab'
                    data-testid='Amortizacion-tab'
                  >
                    <span>{[t("nsAssets.tabs.amortization")]}</span>
                  </div>
                ),
                disabled: false,
              },
              {
                element: (
                  <div
                    key='Detalles generales'
                    data-testid='Detalles-generales-tab'
                  >
                    <span>{[t("nsAssets.tabs.generalDetails")]}</span>
                  </div>
                ),
                disabled: false,
              },
            ]}
            tabTitle={[]}
            tabsContainerTailwind='tw-flex tw-flex-row !tw-mb-6 tw-items-center'
            tabsTailwind='tw-cursor-pointer tw-select-none tw-mr-8 tw-text-primary-50 tw-h-16 tw-flex tw-items-center tw-text-lg'
            tabsActiveTailwind='tw-cursor-pointer tw-select-none tw-mr-8 tw-text-primary tw-font-medium tw-border-0 tw-border-b-4 tw-border-solid tw-border-primary tw-h-16	tw-flex tw-items-center tw-text-lg'
            tabChild={[
              TabAmortizacion({
                openAmortizar,
                esAmortizable: activoByIdData?.esAmortizable,
              }),
              TabDetallesGenerales(),
            ]}
          />
        )}
      </div>
      <aside
        className={`tw-w-1/4 tw-text-left tw-space-y-4 ${
          showTabs ? "tw-pt-24" : "tw-pt-8"
        }`}
      >
        <ResumenAmortizacion />
      </aside>
    </div>
  )
}
